import module from 'colaborador/module.js'
import template from './template.html'
import moment from 'moment'

const diacriticosRegex = /[,.\u0300-\u036f]/g
const diacriticosEspacios = /\s+\s/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').replace(diacriticosEspacios, ' ').toUpperCase().trim()

export class ColaboradorPrestamosExternosComponent {
  idProyecto
  idColaborador
  filtro
  agregando = false
  creditoBloqueado = false
  eliminarConfiguracion = false
  text = ''
  accion = ''
  confirmando = false
  agregar = false
  error = null

  constructor($q, ColaboradorPrestamosExternos, ColaboradorPrestamosExternosCreditoService) {
    this.$q = $q
    this.ColaboradorPrestamosExternos = ColaboradorPrestamosExternos
    this.ColaboradorPrestamosExternosCreditos = ColaboradorPrestamosExternosCreditoService
  }

  $onInit() {
    this.promise = this.$q.all([
      this.ColaboradorPrestamosExternos.get(this.idProyecto, this.idColaborador)
        .then(({ data }) => (this.data = data.map((item) => ({
          descuentoId: item.descuentoId,
          prestamoId: item.prestamoId,
          importe: item.importe,
          abonado: item.abonado,
          concepto: item.concepto,
          descripcion: item.descripcion,
          fecha: moment(item.fecha).format('YYYY-MM-DD'),
          fechaInicial: moment(item.fechaInicial).format('YYYY-MM-DD'),
          concluido: item.concluido,
          busqueda: normalizar(`${item.concepto}-${item.descripcion}-${item.abonado}-${item.importe}`),
        }))))
        .then(() => (this.resultados = this.data))
        .then(() => {
          this.sumatoria = this.resultados.reduce(({ total, abonado }, item) => {
            return {
              total: total + item.importe,
              abonado: abonado + item.abonado
            }
          }, {
            total: 0,
            abonado: 0
          })
        })
        .catch(error => {
          this.error = error.data || error
        }),
      this.ColaboradorPrestamosExternosCreditos.get(this.idProyecto, this.idColaborador)
        .then(({ data }) => {
          if (data.credito == 0) {
            this.creditoBloqueado = true
          } else if (data.credito === null) {
            this.creditoBloqueado = false
          } else {
            this.eliminarConfiguracion = true
          }
        })
    ])

  }

  actualizar(data) {
    this.data = data
  }

  agregar(data) {
    this.agregando = false

    if (data) {
      this.data = [...this.data, data]
    }
  }

  bloquear(text) {
    console.log(text, 'bloquear')
    this.text = text
    this.accion = 'BLOQUEAR'
    this.confirmando = true
  }

  desbloquear(text) {
    console.log(text, 'desbloquear')
    this.text = text
    this.accion = 'DESBLOQUEAR'
    this.confirmando = true
  }

  procesado() {
    this.confirmando = false
    if (this.accion === 'DESBLOQUEAR') {
      this.creditoBloqueado = false
      this.eliminarConfiguracion = false
    } else {
      this.creditoBloqueado = true
    }
  }

  filtrar() {
    let filtro = normalizar(this.filtro)
    this.resultados = this.data.filter((item) => item.busqueda.includes(filtro))
  }

  eliminar(item){
    this.data = this.data.filter((value) => value.descuentoId !== item.descuentoId)
    this.resultados = this.data
  }
}

module.component('colaboradorPrestamosExternos', {
  controller: ColaboradorPrestamosExternosComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/prestamosExternos/component.js